module.exports = __webpack_public_path__ + "static/media/defrost.8166955e.svg";